exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vuxTab .vux-tab {\n  justify-content: space-between;\n}\n.vuxTab .vux-tab-container {\n  height: 4.5rem;\n}\n.vuxTab .vux-tab-item {\n  width: auto !important;\n}", ""]);

// exports
